<div class="input-container">

    <app-svg-icon class="icon" [path]="'assets/icons/calendar_icon.svg'"/>

    <input
      #visibleInput
      class="visible-input"
      [ngModel]="value"
      (dateTimeChange)="onDateChange($event)"
      [required]="required"
      [placeholder]="placeholder || defaultPlaceHolder"
      [disabled]="disabled"
      [readonly]="readonly"
      [owlDateTime]="dateTimePicker"
      [min]="minDate"
      [max]="maxDate"
      [ngClass]="{'form_error': hasError()}"
      [owlDateTimeTrigger]="dateTimePicker"
    >

  <owl-date-time
    [pickerType]="DateTimeTypesVsPickerType[type]"
    [disabled]="disabled"
    [startAt]="minDate"
    [endAt]="maxDate"
    [hour12Timer]="true"
    #dateTimePicker></owl-date-time>


</div>

